import { useEffect } from 'react';
import HeroSlider from './components/HeroSlider';
import TreatmentSection from './components/TreatmentSection';
import AboutSection from './components/AboutSection';
import StaffSection from './components/StaffSection';
import ReviewsSection from './components/ReviewsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { useSEO } from '../../utils/seo';

const HomePage = () => {
  const siteUrl = typeof VITE_SITE_URL !== 'undefined' ? VITE_SITE_URL : 'https://example.com';

  useSEO({
    title: '岡山市の鍼灸院｜おかやま鍼灸院 - 痛み改善・美容鍼・お灸治療',
    description: '岡山市北区のおかやま鍼灸院。肩こり・腰痛・自律神経の不調など、一人ひとりに寄り添うオーダーメイド鍼灸治療。2000年開業、経験豊富な国家資格保持者が施術。完全予約制で待ち時間なし。初回限定割引実施中。',
    keywords: '岡山市 鍼灸院, 岡山 鍼灸, 岡山市北区 鍼灸, 肩こり 改善 岡山, 腰痛 治療 岡山, 美容鍼 岡山, お灸治療, 自律神経 岡山, おかやま鍼灸院',
    canonical: `${siteUrl}/`,
    ogType: 'website',
    schema: {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "おかやま鍼灸院",
      "url": `${siteUrl}/`,
      "logo": "https://public.readdy.ai/ai/img_res/57c68b45-512f-49fb-a7a0-ac00437662e3.png",
      "image": "https://public.readdy.ai/ai/img_res/57c68b45-512f-49fb-a7a0-ac00437662e3.png",
      "description": "岡山市北区の鍼灸院。肩こり・腰痛・自律神経の不調など、一人ひとりに寄り添うオーダーメイド鍼灸治療を提供。",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "○○町1-2-3",
        "addressLocality": "岡山市北区",
        "addressRegion": "岡山県",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 34.6617,
        "longitude": 133.9350
      },
      "telephone": "+81-86-012-3456",
      "faxNumber": "+81-86-012-3457",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          "opens": "09:00",
          "closes": "18:00"
        }
      ],
      "priceRange": "¥¥",
      "foundingDate": "2000"
    }
  });

  return (
    <div className="min-h-screen">
      <HeroSlider />
      <TreatmentSection />
      <AboutSection />
      <StaffSection />
      <ReviewsSection />
      <FAQSection />
      <CTASection />
    </div>
  );
};

export default HomePage;
